<script>
import getSecret from "@utils/get-secret";
import vueFabric from '@components/utils/Fabric';
import JsBarcode from 'jsbarcode';
import { manageStoreMethods } from "@state/helpers";
import vueJsonEditor from 'vue-json-editor'


export default {
    name: 'LabelCanvas',
    props: {
        selectedTag: {
            type: Object,
            required: false,
            default: () => {},
        },
        activeCompanyId: {
            type: String,
            required: false,
            default: '',
        },
        items: {
            type: Array,
            required: true
        },
        onClose: {
            type: Function,
            required: false,
            default: () => {}
        },
        onLabelUpdated: {
            type: Function,
            required: false,
            default: () => {}
        },
    },
    components: { 
        vueFabric,
        vueJsonEditor
    },
    data() {
        return {
            templateRendered: false,
            itemInfo: {},
            references: [],
            templates: [],
            usedVariables: [],
            isLabelSelected: false,
            activeCanvas: {},
            canvasReady: false,
            inputJSON: {},
            canvasScale: 1.3,
            newBarcode: '',
            showJsonEditor: false,
            canvasObjectSelection: {},
            canvasObjectObjectFontFamily: "",
            templateTranslations: {},
            fontFamilies: [
                { value: "Andale Mono", text: "Andale Mono" },
                { value: "Arial Black", text: "Arial Black" },
                { value: "Arial", text: "Arial" },
                { value: "Comic Sans MS", text: "Comic Sans MS" },
                { value: "Courier New", text: "Courier New" },
                { value: "Georgia", text: "Georgia" },
                { value: "Impact", text: "Impact" },
                { value: "Times New Roman", text: "Times New Roman" },
                { value: "Trebuchet", text: "Trebuchet" },
                { value: "Verdana", text: "Verdana" },
            ],
            templateVariables: [
                { value: '$sku', text: "$sku" },
                { value: '$ean', text: "$ean" },
                { value: '$price1', text: "$price1" },
                { value: '$price2', text: "$price2" },
                { value: '$description1', text: "$description1" },
                { value: '$description2', text: "$description2" },
                { value: '$discount1', text: "$discount1" },
                { value: '$discount2', text: "$discount2" },
                { value: '$und', text: "$und" },
            ], 
            selectedInsertImageUrl: null,
            insertImageGallery: [],
        }
    },
    watch: {
        canvasObjectSelection: 'onObjectSelected',
        selectedTag: 'renderTemplate',
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('click', this.handleGlobalClick);
    },
    methods: {
        ...manageStoreMethods,
        getImageGallery(){
            const backUrl = getSecret('SERVER_URL');
            // TODO: Gallery images from back!
            let allImages = [
                { companyId: 'general', files: [
                    backUrl + '/images/general/inknova-logo-new.png',
                    backUrl + '/images/general/logo-triduum-dark.png'
                ]},
                { companyId: '652c8aa54d10e3aaf95db358', files: [
                        backUrl + '/images/652c8aa54d10e3aaf95db358/euro-ahorro-efectivo.png',
                        backUrl + '/images/652c8aa54d10e3aaf95db358/logo-euro.png',
                        backUrl + '/images/652c8aa54d10e3aaf95db358/logo-euro2.png',
                    ]},
                { companyId: '653c0fb8c49433aebd2ed112', files: [
                        backUrl + '/images/653c0fb8c49433aebd2ed112/logo-exito.png',
                    ]},  
                { companyId: '65552bb36e833a44dcbd2e75', files: [
                    // FOR TESTING:
                    // backUrl + '/images/65552bb36e833a44dcbd2e75/logo-chevignon.png',
                    // backUrl + '/images/653c0fb8c49433aebd2ed112/logo-exito.png',
                    backUrl + '/images/652c8aa54d10e3aaf95db358/euro-ahorro-efectivo.png',
                    backUrl + '/images/652c8aa54d10e3aaf95db358/logo-euro.png',
                    backUrl + '/images/652c8aa54d10e3aaf95db358/logo-euro2.png',
                    backUrl + '/images/general/inknova-logo-new.png',
                    backUrl + '/images/general/logo-triduum-dark.png'
                ]}, 
            ]
            if (this.activeCompanyId){
                this.insertImageGallery = [].concat(... Object.values(allImages.filter(x => x.companyId === this.activeCompanyId).map(y => [...y.files] )))
            } else {
                this.insertImageGallery = [].concat(... Object.values(allImages.map(y => [...y.files] )))
            }
        },
        async mixTemplateData(obj){
            let result = null
            if (obj.type === 'textbox' && obj.metadata && obj.metadata.substring(0, 3) == "%t."){
                this.usedVariables.push(obj.metadata.replace(':',''))
                for (const [key, value] of Object.entries(this.templateTranslations)){
                    if (key == (obj.metadata).substring(3).replace(":","")){
                        obj.text = value.toString();
                        result = 'text'
                    }
                }
            } else if (obj.type === 'textbox' && obj.metadata && obj.metadata.substring(0, 1) === '$'){
                this.usedVariables.push(obj.metadata)
                let _item_info = Object.keys(this.itemInfo).length > 0 ? this.itemInfo[obj.metadata.replace('$','')] : obj.metadata
                if (!_item_info || this.itemInfo[obj.metadata.replace('$','')] === ''){
                    _item_info = obj.metadata
                    result = 'text';
                }  
                if (obj.metadata.indexOf('$price') > -1){
                    try {
                        _item_info = `\$${_item_info.toLocaleString('ES-es', {useGrouping: true})}`
                    } catch {
                        _item_info = obj.metadata
                    }
                } 
                obj.text = `${_item_info}`
                result = 'text'
            } else if (obj.type === 'image' && obj.metadata && obj.metadata.substring(0, 1) === '$'){
                let _item_info = Object.keys(this.itemInfo).length > 0 ? this.itemInfo[obj.metadata.replace('$','')] : obj.metadata
                obj.src = this.getBarcode(_item_info)
                result = 'barcode'
            } else {
                result = null
            }
            return { obj , result }
        },
        async renderTemplate(template={name:''}){
            if (!template.id && template.name !== '') { // cuando no es un tag, sino un template (temporal)
                this.selectedTag.template = template.name
                this.selectedTag.reference_id = template.reference
            }
            if (this.selectedTag.item_id){
                this.itemInfo = _.cloneDeep(await this.items.find(y => y.ean === this.selectedTag.item_id))
            } else {
                this.itemInfo = null;
            }
            this.isLabelSelected = true
            this.activeCanvas = this.$refs[`label-${this.selectedTag.reference_id}`][0];
            this.activeCanvas.clear();
            this.canvasReady = null
            await this.fetchTemplate({ ref: this.selectedTag.reference_id, templateId: template.name || this.selectedTag.template })
            .then(async (json) => { 
                this.canvasReady = false
                this.inputJSON = json.data; 
                let context = this
                this.inputJSON.labelData.objects.forEach(async function(_obj){
                    let { obj, result } = await context.mixTemplateData(_obj);
                    if (result){
                        if (result === 'barcode'){
                            obj.src = context.activeCanvas.renderAll.bind(context.activeCanvas)
                        }
                        _obj = obj
                    }
                });
                await this.activeCanvas.loadFromJSON2(this.inputJSON.labelData)
                this.canvasReady = true
                this.activeCanvas.renderAll();
            }).catch((e) => { 
                console.error("Error:", e);
            });
        },
        loadLocalJSON(URL){
            fetch(URL).then(async (response) => {
                if (!response.ok) {
                    throw new Error('No se pudo cargar el archivo JSON.');
                }
                this.templateTranslations = await response.json();
            })
            .catch((error) => {
                return {};
            });
        },
        onFabricEvent(type, event){
            let canvas = this.activeCanvas;
            if(type == 'up'){
                // console.log(json)
                this.refreshJson()
            } else if(type == 'over'){
                // console.log('over', event)
            } else if(type == 'down'){
                this.refreshJson()
            } 
        },
        onFabricSelect(obj, option){
            // console.log(obj, option)
            let canvas = this.activeCanvas;
            if (this.isEditAvailable){
                canvas.setSelection(true)
                this.canvasObjectSelection = canvas.getEditObj();
            } else {
                canvas.discardActive()
            }
        },
        refreshJson(){
            this.inputJSON.labelData = this.activeCanvas.toJson()
        },
        onObjectSelected() {
            if (this.canvasObjectSelection && this.canvasObjectSelection.type === 'textbox'){
                this.canvasObjectObjectFontFamily = this.canvasObjectSelection.fontFamily
            }
        },
        getBarcode(barcode='1234567890'){
            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("width", 120);
            svg.setAttribute("height", 50);
            
            JsBarcode(svg, barcode, {
                format: 'CODE128',
                displayValue: false,
                width: 2,
                height: 50,
                margin: 4,
            });
            let barcodeImage = new XMLSerializer().serializeToString(svg);
            let data = 'data:image/svg+xml,' + encodeURIComponent(barcodeImage)
            // console.log("generando: ", barcode, data)
            return data
        },
        async newFabricElement(type){
            let canvas = this.activeCanvas;
            let new_id = `${type}-${Math.floor(Math.random() * 10000).toString().padStart(5, '1')}`;
            if (type.indexOf('$') > -1 || type.indexOf('%t.') > -1){
                let { obj, response } = await this.mixTemplateData({ type: 'textbox', text: '', metadata: type })
                await canvas.createTextbox(obj.text, { id: new_id, metadata: obj.metadata, width: 12 * (obj.text.length), height: 20, left: 10, top: (canvas.height/2)-10, fontSize: 12, fontFamily: 'Arial', fill: 'rgb(0,0,0)' });
            } else {
                switch (type) {
                    case 'textbox': await canvas.createTextbox('Texto', { id: new_id, width: 40, height: 30, left: (canvas.width/2)-30, top: (canvas.height/2)-10, fontSize: 20, fontFamily: 'Arial', fill: 'rgb(0,0,0)' }); break;
                    case 'rect': await canvas.createRect({ id: new_id, width: 40, height: 30, left: 10, top: 10, fill: 'rgb(0,0,0)', strokeWidth: 0 }); break;
                    case 'circle': await canvas.createCircle({ id: new_id, width: 40, height: 30, left: 10, top: 10, fill: 'rgb(0,0,0)', strokeWidth: 0 }); break;
                    case 'line': await canvas.createLine({ id: new_id, x1: 40, y1: 10, left: 10, top: 10, stroke: 'rgb(0,0,0)' }); break;
                    case 'barcode': await canvas.createImage(this.getBarcode(), { id: new_id, width: 60, height: 40, left: 10, top: 10, metadata: '$ean' }); break;
                    case 'current-time': await canvas.createTextbox(new Date().toLocaleString('en-US', { hour12: true }), { id: new_id, metadata: '%f.updated_at', width: 12 * 17, height: 20, left: 10, top: (canvas.height/2)-10, fontSize: 12, fontFamily: 'Arial', fill: 'rgb(0,0,0)' }); break;
                    case 'image': await canvas.createImage(this.selectedInsertImageUrl, { id: new_id, metadata: '%i.company_logo', height: 100, left: 10, top: 10 }); break;
                    case 'svg': await canvas.loadSVGFromString(`http://localhost:8081/flags/${(() => { var f = 'ar,bo,br,ca,ch,cl,co,de,ec,es,fr,gt,it,mx,ni,nl,pa,pe,pr,pt,ru,sv,us,uy,ve'; var i = Math.floor(Math.random() * f.split(',').length); return f.split(',')[i];  })() }.svg`, { id: new_id, width: 100, height: 100, left: 10, top: 10 }); break;
                }
            }
            await setTimeout(async () => {
                this.canvasObjectSelection = canvas.getObjectById(new_id);
            }, 500);
        },
        setFabricTextStyle(style){
            this.canvasObjectSelection = this.activeCanvas.setTextStyle(style);
        },
        setFabricTextAlign(align){
            this.canvasObjectSelection = this.activeCanvas.setTextAlign(align);
        },
        setFabricFontSize(value){
            this.canvasObjectSelection = this.activeCanvas.setTextSize(value);
        },
        setFabricTextWeight(weight){
            this.canvasObjectSelection = this.activeCanvas.setTextWeight(weight);
        },
        setFabricTextValue(id, value){
            this.activeCanvas.setTextValue(id, value);
        },
        setFabricFontFamily(font){
            this.canvasObjectSelection = this.activeCanvas.setTextFontFamily(font)
        },
        setFabricColor(color){
            this.canvasObjectSelection = this.activeCanvas.setObjectFillColor(color);
        },
        setFabricBring(place){
            if (place === 'bottom'){ this.activeCanvas.toBottomLayer(); }
            else if (place === 'top'){ this.activeCanvas.toTopLayer(); }
            else if (place === 'last'){ this.activeCanvas.toLastLayer(); }
            else if (place === 'next'){ this.activeCanvas.toNextLayer(); }
        },
        setFabricRotate(deg){
            this.canvasObjectSelection = this.activeCanvas.setRotate(deg)
        },
        removeFabricCurrent(){
            this.activeCanvas.removeCurrentObj();
        },
        cloneFabricCurrent(){
            this.activeCanvas.cloneCurrentObject();
        },
        setCanvasZoom(type){
            const divElements = this.$refs.canvasContainer;
            for (const divElement of divElements) {
                const activeElement = divElement.querySelector('.case-active');
                if (activeElement) {
                    this.canvasScale += type === 'in' ? 0.1 : type === 'out' ? -0.1 : 0;
                    activeElement.style.scale = this.canvasScale;
                    break;
                }
            }
        },
        saveTemplate(){
            let canvas = this.activeCanvas;
            let json = canvas.toJson();
            this.inputJSON.labelData = json
            this.updateTemplateCode({
                reference: this.selectedTag.reference_id, 
                template: this.selectedTag.template,
                JSON : this.inputJSON
            }).then((resp) => {
                // console.info(resp)
                this.$generate_toast(
                this,
                'success',
                `${this.$t('fields.template')} ${this.$t('basic.updated')} ${this.$t('basic.correctly')}`
                )
                this.onLabelUpdated()
                this.fetchTemplates().then((response) => {
                    this.templates = _.cloneDeep(response.data.results);
                })
            }).catch(e => {
                console.error(e)
                this.$generate_toast(
                this,
                'error',
                `${this.$t('fields.template')} no ${this.$t('basic.updated')} ${this.$t('basic.correctly')}`
                )
            })
            // console.log(this.activeCanvas.toDataUrl());
        },
        assignTemplateToLabel(){
            const labelId = this.selectedTag._id
            const templateId = this.selectedTag.template
            this.updateLabelSetTemplate({ labelId, templateId }).then((resp) => {
                this.toggleRightSidebar(); 
                this.$generate_toast(
                    this,
                    'success',
                    `${this.$t('fields.label')} ${this.$t('basic.updated2')} ${this.$t('basic.correctly')}`
                )
                this.onClose()
                // this.getAccessPointDevices(this.activeAccessPoint)
            }).catch(e => {
                console.error(e)
                this.$generate_toast(
                    this,
                    'error',
                    `${this.$t('fields.label')} no ${this.$t('basic.updated')} ${this.$t('basic.correctly')}`
                )
            })
        },
        
        handleKeyDown(event) {
            // console.log("Key:", event.key)
            // console.log(this.canvasObjectSelection)
            if ((event.key === 'Backspace' || event.key === 'Delete') 
            && (document.activeElement.tagName !== 'INPUT' && this.canvasObjectSelection.type !== 'textbox' || 
            (this.canvasObjectSelection.type === 'textbox' && this.canvasObjectSelection.isEditing !== true))) {
                this.removeFabricCurrent();
            }
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'ArrowRight'){
                this.activeCanvas.moveObjectTo(event.key.replace('Arrow','').toLowerCase());
            }
            if (event.key === 'Escape' && Object.keys(this.selectedTag).length > 0 && this.canvasReady) {
                this.activeCanvas.discardActive();
                this.canvasObjectSelection = {}
                this.canvasObjectObjectFontFamily = ""
            }
        },
        handleGlobalClick(event) {
            const container = document.getElementById('canvas-container');
            
            if (container) {
                const canvasRect = container.getBoundingClientRect();
                const clickX = event.clientX;
                const clickY = event.clientY;
                
                if (
                clickX >= canvasRect.left &&
                clickX <= canvasRect.right &&
                clickY >= canvasRect.top &&
                clickY <= canvasRect.bottom
                ) {
                    // console.log('Clic dentro del canvas');
                } else if (this.selectedTag.reference_id && this.canvasReady) {
                    this.activeCanvas.discardActive();
                    this.canvasObjectSelection = {}
                    this.canvasObjectObjectFontFamily = ""
                }
            }
        },
        toggleRightSidebar(){
            document.body.classList.toggle('right-bar-enabled')
        }
    },
    computed: {
        isEditAvailable(){
            return this.$store.state.auth.currentSession.user.is_superuser
        },
    },
    beforeMount() {
        // TODO: TO CACHE!!!!
        this.fetchReferences().then((response) => {
            this.references = _.cloneDeep(response.data.results);
        }),
        this.fetchTemplates().then((response) => {
            this.templates = _.cloneDeep(response.data.results);
        })
        this.loadLocalJSON(`http://192.168.1.37:3000/templates/languages/es.json`);

    },
    mounted(){
        this.$nextTick(() => {
            if (this.$refs[`label-${this.selectedTag.reference_id}`] && !this.templateRendered){
                this.renderTemplate();
                this.templateRendered = true
                document.addEventListener('keydown', this.handleKeyDown);
                document.addEventListener('click', this.handleGlobalClick);
            }
        });
        
    },

    updated(){
        this.$nextTick(() => {
            if (this.$refs[`label-${this.selectedTag.reference_id}`] && !this.templateRendered){
                this.renderTemplate();
                this.getImageGallery();
                this.templateRendered = true
                document.addEventListener('keydown', this.handleKeyDown);
                document.addEventListener('click', this.handleGlobalClick);
            }
        });
    }
}
</script>



<template>
    <div>
        <div class="h3" v-if="selectedTag" >
            <i class="fad fa-circle-info font-16"></i> Ref: {{ selectedTag.reference_id }} <small><b>{{ inputJSON.title }}</b> {{ inputJSON.description }}</small>
        </div>
        <b-row id="canvas-container">
            <b-col v-if="selectedTag"  >
                <b>{{ $t('fields.template') }}: </b>
                <b-button 
                    v-for="template in templates.filter(x => x.reference === selectedTag.reference_id)" :key="template.reference+template.name" 
                    @click="() => { renderTemplate(template) }" 
                    class="px-2 py-1 mb-1 mr-1"
                    :class="{ 'text-white bg-primary' : template.name === selectedTag.template}"
                    >{{ template.name }}</b-button>
            </b-col>
            <b-col :lg="12" :md="12" v-for="reference in references" :key="reference.id" class="p-1 px-2 mb-2" 
                ref="canvasContainer" :style="`min-height: ${((reference.screen_height * canvasScale) + 28) }px`"
                :class="{ 'd-none': Object.keys(selectedTag).length === 0 || !selectedTag || (selectedTag && reference.id !== selectedTag.reference_id) }"
                >
                <div class="p-1">
                    <small class="text-muted">
                        REF: {{ reference.id }} 
                        - {{ reference.inches }} 
                        - {{ reference.type == 'WF' ? 'Wifi Frío' : reference.type == 'WN' ? 'Wifi Normal' : reference.type == 'BF' ? 'Bluetooth Frío' : reference.type == 'BN' ? 'Bluetooth Normal' : ''  }} 
                        - Dimensiones: {{ reference.screen_width }} * {{ reference.screen_height }}
                    </small> 
                    <b-badge v-if="canvasObjectSelection && canvasObjectSelection.metadata" pill class="text-white bg-info ml-2 px-2 py-1">Variable: {{ canvasObjectSelection.metadata }}</b-badge>
                </div>
                <div 
                    class="case-container mb-5" 
                    :class="{ 'bg-white' : reference.case_color === 'white',
                    'bg-blue' : reference.case_color === 'blue', 
                    'bg-black' : reference.case_color === 'black',
                    'd-none' : Object.keys(selectedTag).length === 0 || !selectedTag || (selectedTag && reference.id !== selectedTag.reference_id),
                    'case-active' : selectedTag && reference.id === selectedTag.reference_id }">
                    <vue-fabric 
                        :ref="`label-${reference.id}`" 
                        :id="`canvas-${reference.id}`" 
                        :data-ref="reference.id"
                        :width="reference.screen_width" 
                        :height="reference.screen_height" 
                        @mouse:up="(event) => onFabricEvent('up', event)" 
                        @mouse:out="(event) => onFabricEvent('out', event)"
                        @mouse:down="(event) => onFabricEvent('down', event)"
                        @selection:created="onFabricSelect"
                        @selection:updated="onFabricSelect"
                        >
                    </vue-fabric>
                </div>
                <div class="zoom-buttons">
                    <b-button pill variant="transparent" size="lg" class="p-1" @click="setCanvasZoom('in')" ><i class="text-blue font-16 fad fa-magnifying-glass-plus"></i></b-button>
                    <span class="text-blue">{{ Math.round(canvasScale * 100) }}%</span>
                    <b-button pill variant="transparent" size="lg" class="p-1" @click="setCanvasZoom('out')" ><i class="text-blue font-16 fad fa-magnifying-glass-minus"></i></b-button>
                </div>
            </b-col>
            <b-col v-if="selectedTag.reference_id && isEditAvailable"  style="min-height: 120px" >
                <b-button-toolbar class="canvas-toolbar my-2">
                    <b-button-group class="mx-1 mb-1">
                        <b-button variant="silver" class="pr-2" @click="newFabricElement('textbox')"><i class="fad fa-text"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="newFabricElement('rect')"><i class="fad fa-draw-square"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="newFabricElement('circle')"><i class="fad fa-draw-circle"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="newFabricElement('line')"><i class="fad fa-dash"></i></b-button>
                        <b-dropdown variant="silver">
                            <template #button-content >
                                <i class="fad fa-image text-black"></i>
                            </template>
                            <b-dropdown-form>
                                <div style="display: flex; flex-wrap: wrap; gap: 10px; width: 320px">
                                    <b-button v-for="url in insertImageGallery" :key="url" 
                                        variant="link" class="d-block" 
                                        @click="() => { selectedInsertImageUrl = url; newFabricElement('image') }" 
                                        style="width: 100px; height: 100px; background-color: rgba(219, 219, 219, 0.951)">
                                        <b-img :src="url" fluid />
                                    </b-button>
                                </div>
                            </b-dropdown-form>
                        </b-dropdown>
                        <b-button variant="silver" class="px-2" @click="newFabricElement('svg')"><i class="fad fa-stars"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="newFabricElement('barcode')"><i class="fad fa-barcode"></i></b-button>
                        <b-button variant="silver" class="pl-2" @click="newFabricElement('current-time')"><i class="fad fa-calendar-clock"></i></b-button>
                        <b-dropdown variant="silver">
                            <template #button-content>
                                <span class="text-black"><i class="fad fa-message-text "></i> Variables</span>
                            </template>
                            <b-dropdown-item v-for="variable in templateVariables" 
                                :key="variable.value" 
                                @click="newFabricElement(variable.value)" 
                                :disabled___="usedVariables.includes(variable.value)"
                                ><i class="fad fa-message-dollar" :class="{ 'text-blue' : !usedVariables.includes(variable.value)}"></i> {{ $t(`labels.templateVariables.${variable.text}`) }}
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item v-for="entry in Object.entries(templateTranslations)" 
                                :key="`translation-${entry[0]}`"
                                @click="newFabricElement(`%t.${entry[0]}`)" 
                                :disabled___="usedVariables.includes(`%t.${entry[0]}`)"
                                ><i class="fad fa-language" :class="{ 'text-blue' : !usedVariables.includes(`%t.${entry[0]}`)}"></i> {{ entry[1] }} 
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                    <b-button-group class="mx-1 mb-1" v-if="canvasObjectSelection && Object.keys(canvasObjectSelection).length > 0">
                        <b-button variant="silver" class="pr-2" @click="removeFabricCurrent()"><i class="fad fa-trash"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="cloneFabricCurrent()"><i class="fad fa-clone"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="setFabricBring('bottom')" ><i class="fad fa-send-back"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="setFabricBring('last')" ><i class="fad fa-bring-forward"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="setFabricBring('top')" ><i class="fad fa-bring-front"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="setFabricBring('next')" ><i class="fad fa-send-backward"></i></b-button>
                        <b-button variant="silver" class="pl-2" @click="setFabricRotate(45)" ><i class="fad fa-rotate-right"></i></b-button>
                    </b-button-group>

                    <!-- TEXTBOX  TOOLBAR -->
                    <b-button-group v-if="canvasObjectSelection && canvasObjectSelection.type == 'textbox'" class="mx-1 mb-1 rounded-sm">
                        <b-button variant="silver" class="pr-2" :pressed="canvasObjectSelection.fontWeight === 'bold'" @click="setFabricTextWeight('bold')"><i class="fad fa-bold"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.fontStyle === 'italic'"  @click="setFabricTextStyle('italic')"><i class="fad fa-italic"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.underline === true"  @click="setFabricTextStyle('underline')"><i class="fad fa-underline"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.linethrough === true"  @click="setFabricTextStyle('linethrough')"><i class="fad fa-strikethrough"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.textAlign === 'left'" @click="setFabricTextAlign('left')"><i class="fad fa-align-left"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.textAlign === 'right'"  @click="setFabricTextAlign('right')"><i class="fad fa-align-right"></i></b-button>
                        <b-button variant="silver" class="px-2" :pressed="canvasObjectSelection.textAlign === 'center'"  @click="setFabricTextAlign('center')"><i class="fad fa-align-center"></i></b-button>
                        <b-button variant="silver" class="pl-2" :pressed="canvasObjectSelection.textAlign === 'justify'"  @click="setFabricTextAlign('justify')"><i class="fad fa-align-justify"></i></b-button>
                    </b-button-group>

                    <b-button-group v-if="canvasObjectSelection && canvasObjectSelection.type == 'textbox'" class="mx-1 mb-1">
                        <b-input-group class="bg-silver text-white" size="sm">
                            <b-input-group-prepend>
                                <b-button variant="silver"><i class="fad fa-text-size"></i></b-button>
                            </b-input-group-prepend>
                            <b-form-input type="number" @change="setFabricFontSize" :value="canvasObjectSelection.fontSize ? canvasObjectSelection.fontSize : ''" class="input-text-size mt-1"></b-form-input>
                        </b-input-group>
                        <b-input-group class="bg-silver text-white pr-1" size="sm">
                            <b-input-group-prepend>
                                <b-button disabled variant="silver"><i class="fad fa-font"></i></b-button>
                            </b-input-group-prepend>
                            <b-form-select v-model="canvasObjectSelection.fontFamily" :options="fontFamilies" @change="setFabricFontFamily" class="mt-1" style="height: 26px; padding: 1px 3px"></b-form-select>
                        </b-input-group>
                        <b-input-group class="bg-silver text-white" size="sm">
                            <b-input-group-prepend>
                                <b-button disabled variant="silver"><i class="fad fa-palette"></i></b-button>
                            </b-input-group-prepend>
                            <b-input-group-append>
                                <div class="p-1 m-1 rounded-sm" style="background-color: rgba(255,255,255,0.5); display: inline-flex; flex-flow: row; grid-gap: 4px;">
                                    <b-button :style="`background-color: rgb(255,255,255); position: relative; width: 16px; height: 16px; padding: 0px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,255,255)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,255,255)')"></b-button>
                                    <b-button v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('R') >= 0" :style="`background-color: rgb(255,0,0); position: relative; width: 16px; height: 16px; padding: 0px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,0,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,0,0)')"></b-button>
                                    <b-button v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('Y') >= 0" :style="`background-color: rgb(255,255,0); position: relative; width: 16px; height: 16px; padding: 0px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,255,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,255,0)')"></b-button>
                                    <b-button v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('B') >= 0" :style="`background-color: rgb(0,0,0); position: relative; width: 16px; height: 16px; padding: 0px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(0,0,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(0,0,0)')"></b-button>
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-button-group>

                    <!-- RECTANGLE/CIRCLE  TOOLBAR -->
                    <b-button-group v-if="canvasObjectSelection && (canvasObjectSelection.type == 'rect' || canvasObjectSelection.type == 'circle' || canvasObjectSelection.type == 'line')" class="mx-1 mb-1">
                        <b-input-group class="bg-silver text-white rounded-sm" size="sm">
                            <b-input-group-prepend>
                                <b-button disabled variant="silver"><i class="fad fa-palette"></i></b-button>
                            </b-input-group-prepend>
                            <b-input-group-append>
                                <div class="p-1 m-1 rounded-sm" style="background-color: rgba(255,255,255,0.5); display: inline-flex; flex-flow: row; grid-gap: 4px;">
                                    <a :style="`background-color: rgb(255,255,255); position: relative; width: 16px; height: 16px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,255,255)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,255,255)')"></a>
                                    <a v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('R') >= 0" :style="`background-color: rgb(255,0,0); position: relative; width: 16px; height: 16px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,0,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,0,0)')"></a>
                                    <a v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('Y') >= 0" :style="`background-color: rgb(255,255,0); position: relative; width: 16px; height: 16px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(255,255,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(255,255,0)')"></a>
                                    <a v-if="references.find(x => x.id === selectedTag.reference_id).tint_colors.indexOf('B') >= 0" :style="`background-color: rgb(0,0,0); position: relative; width: 16px; height: 16px; border: 2px solid ${canvasObjectSelection.fill === 'rgb(0,0,0)' ? 'black' : 'transparent' }`" @click="setFabricColor('rgb(0,0,0)')"></a>
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-button-group>
                    <b-button-group class="mx-1 mb-1">
                        <b-button variant="silver" class="px-2" :pressed="showJsonEditor" @click="() => { showJsonEditor = !showJsonEditor; refreshJson() }" ><i class="fad fa-code"></i></b-button>
                        <b-button variant="silver" class="px-2" @click="saveTemplate()"><i class="fad fa-floppy-disk"></i></b-button>
                        <b-button variant="silver" class="pl-2"><i class="fad fa-xmark"></i></b-button>
                    </b-button-group> 
                </b-button-toolbar>
            </b-col>
            <b-col v-else >
                <b-button-toolbar class="canvas-toolbar my-2">
                    <b-button-group class="mx-1 mb-1">
                        <b-button variant="primary" class="pr-2" @click="setCanvasZoom('in')" ><i class="fad fa-magnifying-glass-plus"></i></b-button>
                        <b-button variant="primary" class="px-2" @click="setCanvasZoom('out')" ><i class="fad fa-magnifying-glass-minus"></i></b-button>
                        <b-button variant="primary" class="px-2" @click="assignTemplateToLabel()"><i class="fad fa-floppy-disk"></i></b-button>
                    </b-button-group>  
                </b-button-toolbar>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <vueJsonEditor v-if="showJsonEditor" v-model="inputJSON.labelData.objects" :show-btns="false" mode="code" :expandedOnStart="false"/>
                <!-- @json-change="drawLabel" @json-save="drawLabel"  -->
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button variant="primary" size="md" class="mr-1" @click="assignTemplateToLabel()"><i class="fad fa-floppy-disk"></i> Asignar</b-button>
                <b-button variant="primary" size="md" @click="toggleRightSidebar()" ><i class="fad fa-x"></i> Cancelar</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss" scoped>
$gray-200: #DCDCDC;
.btn-silver {
    background-color: $gray-200 !important;
    color: black;
    box-shadow: none
}
.btn-silver.active {
    background-color: darken($gray-200, 20%) !important;
}
.zoom-buttons {
    position: absolute;
    top: 50%;
    right: 5px;
    display: grid;
    margin-top: -52px;
}
.canvas-toolbar {
    .fad-solid::after {
        opacity: var(--fa-secondary-opacity, 1);
    }
    .input-text-size {
        width: 50px !important; height: 26px !important; padding-right: 2px; padding-left: 2px; text-align: right;
    }
    .dropdown-menu {
        ul.show {
            box-shadow: 5px 5px 5px 0 rgba(58,53,65,.18),0 2px 8px 1px rgba(58,53,65,.12),0 2px 12px 1px rgba(58,53,65,.04);
        }
        li {
            padding: 0;
            a {
                padding: 0.1rem 0.3rem;
            }
        }
        .b-dropdown-form {
            padding: 0;
        }
    } 
}
.case-container {
    transform-origin: 0px 0px;
    scale: 1.3;
    display: inline-block; 
    background-color: white;
    padding: 14px 49px 23px 37px;
    border-radius: 10px;
    box-shadow: 0 4px 5px -2px rgba(58,53,65,.08),0 2px 8px 1px rgba(58,53,65,.12),0 2px 12px 1px rgba(58,53,65,.04);
    canvas {
        border: 5px solid rgb(216, 216, 216);
        box-sizing: content-box;
    }
    .upper-canvas {
        box-shadow: inset 3px 3px 10px rgba(0, 0, 0, 0.3);
        background-color: rgba(0,0,0,0.04);
    }
    &.bg-blue {
        background-color: rgb(179, 252, 255) !important;
    }
    &.bg-black {
        background-color: rgb(24, 24, 24) !important;
    }
    &.bg-white {
        background-color: rgb(255, 255, 255) !important;
    }
}
</style>